const websites = {
	gn: {
		name: "geneious",
		url: "https://www.geneious.com",
	},
	gp: {
		name: "graphpad",
		url: "https://www.graphpad.com",
	},
	sg: {
		name: "snapgene",
		url: "https://www.snapgene.com",
	},
	om: {
		name: "omiq",
		url: "https://www.omiq.ai",
	},
	la: {
		name: "labarchives",
		url: "https://www.labarchives.com",
	},
	pm: {
		name: "proteinmetrics",
		url: "https://www.proteinmetrics.com",
	},
	fe: {
		name: "denovosoftware",
		url: "https://www.denovosoftware.com",
	},
	ep: {
		name: "easy-panel",
		url: "https://flow-cytometry.net",
	},
	nq: {
		name: "n-query",
		url: "https://www.statsols.com",
	},
	ms: {
		name: "m-star",
		url: "https://mstarcfd.com",
	},
	sfg: {
		name: "softgenetics",
		url: "https://softgenetics.com",
	},
};
const currentAnchorProps = {
	href: "#",
	className: "topbar-toggle-action",
	onClick: e => e.preventDefault(),
};

const utmLink = brandCode => {
	const setAnchorProps = (source, key) => {
		const params = `?utm_medium=referral&utm_source=${websites[source].name}&utm_campaign=dotmatics-top-bar`;
		return {
			href: `${websites[key].url}/${params}`,
			target: "_blank",
		};
	};
	const gnProps = brandCode === "gn" ? currentAnchorProps : setAnchorProps(brandCode, "gn");
	const gpProps = brandCode === "gp" ? currentAnchorProps : setAnchorProps(brandCode, "gp");
	const sgProps = brandCode === "sg" ? currentAnchorProps : setAnchorProps(brandCode, "sg");
	const omProps = brandCode === "om" ? currentAnchorProps : setAnchorProps(brandCode, "om");
	const laProps = brandCode === "la" ? currentAnchorProps : setAnchorProps(brandCode, "la");
	const pmProps = brandCode === "pm" ? currentAnchorProps : setAnchorProps(brandCode, "pm");
	const feProps = brandCode === "fe" ? currentAnchorProps : setAnchorProps(brandCode, "fe");
	const epProps = brandCode === "ep" ? currentAnchorProps : setAnchorProps(brandCode, "ep");
	const nqProps = brandCode === "nq" ? currentAnchorProps : setAnchorProps(brandCode, "nq");
	const msProps = brandCode === "ms" ? currentAnchorProps : setAnchorProps(brandCode, "ms");
	const sfgProps = brandCode === "sfg" ? currentAnchorProps : setAnchorProps(brandCode, "sfg");

	return {
		gnProps,
		gpProps,
		sgProps,
		omProps,
		laProps,
		pmProps,
		feProps,
		epProps,
		nqProps,
		msProps,
		sfgProps,
	};
};

export default utmLink;
